// extracted by mini-css-extract-plugin
export default {"content_wrapper":"UpcomingPage_content_wrapper__12QZ2","section_title":"UpcomingPage_section_title__k8oSl"};